import React from 'react'

const EncuestaEnd = () => {
    return (
        <div className='EncuestaEnd' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <img src={process.env.REACT_APP_Logo_Primario_H} alt="" className="login__empresa-logo" />
            <h1>Gracias por completar nuestra encuesta.</h1>
        </div>
    )
}

export default EncuestaEnd